import { Navigate, Route, Routes } from "react-router-dom";
import NCAdd from "../screens/SMQ/NC/NCAdd";
import Dashboard from "../screens/SMQ/dashboard/Dashboard";
import ActionTypes from "../screens/SMQ/parameter/ActionTypes";
import ExigenceTypes from "../screens/SMQ/parameter/ExigenceTypes";
import TriggerTypes from "../screens/SMQ/parameter/TriggerTypes";
import Referentiel from "../screens/SMQ/processus/Referentiel";
import Cartographie from "../screens/SMQ/processus/Cartographie";
import Processus from "../screens/SMQ/processus/Processus";
import Direction from "../screens/SMQ/processus/Direction";
import RegistreList from "../screens/SMQ/registre/RegistreList";
import CorbeilleList from "../screens/SMQ/registre/CorbeilleList";
import AnalyseList from "../screens/SMQ/registre/AnalyseList";
import ReopenedList from "../screens/SMQ/registre/ReopenedList";
import SuiviList from "../screens/SMQ/suivi/SuiviList";
import OutilContainer from "../screens/SMQ/outils/OutilContainer";
import ExportExcel from "../screens/SMQ/data/ExportExcel";
import ImportNC from "../screens/SMQ/Import/ImportNC";
import GuideUtilisateur from "../screens/SMQ/guide/GuideUtilisateur";

const SMQRoute = () => {
  return (
    <Routes>
      <Route index element={<Navigate replace to="dashboard" />} />
      <Route path="dashboard" element={<Dashboard />} />
      <Route
        path="parametrage/types-declencheur"
        element={<TriggerTypes />}
      />
      <Route
        path="parametrage/types-exigence"
        element={<ExigenceTypes />}
      />
      <Route path="parametrage/types-action" element={<ActionTypes />} />
      <Route path="parametrage-processus/referentiel" element={<Referentiel />} />
      <Route path="parametrage-processus/cartographie" element={<Cartographie />} />
      <Route path="parametrage-processus/processus" element={<Processus />} />
      <Route path="parametrage-processus/directions" element={<Direction />} />
      <Route path="add" element={<NCAdd />} />
      <Route path="registre" element={<RegistreList />} />
      <Route path="reouvertes" element={<ReopenedList />} />
      <Route path="corbeille" element={<CorbeilleList />} />
      <Route path="analyser" element={<AnalyseList />} />
      <Route path="suivi-efficacite" element={<SuiviList />} />
      <Route path="export" element={<ExportExcel />} />
      <Route path="import" element={<ImportNC />} />
      <Route path="guide" element={<GuideUtilisateur />} />
      <Route path="processus/outils/:processus_id" element={<OutilContainer />} />
    </Routes>
  );
};

export default SMQRoute;
